import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "ordinalDateTime",
    standalone: false
})
export class OrdinalDateTimePipe implements PipeTransform {
	transform(value: Date): string {
		if (!value) {
			return "";
		}
		const months = [
			"Jan",
			"Feb",
			"Mar",
			"Apr",
			"May",
			"Jun",
			"Jul",
			"Aug",
			"Sep",
			"Oct",
			"Nov",
			"Dec",
		];
		return `${value.getDate()}${this.nth(value.getDate())} ${
			months[value.getMonth()]
		} ${value.getFullYear()}`;
	}

	nth(d) {
		if (d > 3 && d < 21) {
			return "th";
		}
		switch (d % 10) {
			case 1:
				return "st";
			case 2:
				return "nd";
			case 3:
				return "rd";
			default:
				return "th";
		}
	}
}
